<template>
  <div>
    <!-- 项目组件 -->
    <el-select v-model="project" placeholder="请选择" v-bind="attrs" clearable filterable>
      <el-option v-if="!Object.hasOwn(attrs, 'multiple') && showAllOption" label="全部" value="" />
      <el-option v-for="item in projectList" :key="item.id" :label="item[label]" :value="item[value]" />
    </el-select>
  </div>
</template>

<script setup>
import { getProjectList } from '@/api/subject';

const props = defineProps({
  modelValue: {
    type: [String, Array],
    require: true,
  },
  label: {
    type: String,
    default: 'projectName',
  },
  value: {
    type: String,
    default: 'id',
  },
  showAllOption: {
    type: Boolean, //是否显示第一项'全部'
    default: true,
  },
});

const emits = defineEmits(['update:modelValue']);
const attrs = useAttrs();

const projectList = ref([]); // 项目列表

const project = computed({
  get() {
    if (Object.hasOwn(attrs, 'multiple')) {
      return Array.isArray(props.modelValue) ? [...props.modelValue] : props.modelValue ? props.modelValue.split(',') : [];
    } else {
      return props.modelValue ?? '';
    }
  },
  set(val) {
    emits('update:modelValue', val);
  },
});

onMounted(() => {
  handleProject();
});

//获取项目数据
async function handleProject() {
  const res = await getProjectList();
  if(res.data){
    projectList.value = res.data
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-select) {
  width: 260px;
  .el-select__wrapper {
    .el-select__selection {
      flex-wrap: nowrap;
    }
  }
}
</style>
